import { useSetRecoilState } from "recoil";
import { useHistory } from "react-router-dom";

import subMenuSelectionState from "../../../states/subMenuSelectionState";
import SubMenuSelectItem from "../input/SubMenuSelectItem";

function SubMenuItem ( props ) {

    const setSubMenuSelection = useSetRecoilState(subMenuSelectionState);
    const history = useHistory();

    const onClick = () => {

        setSubMenuSelection ( props.menuItem.subMenuItemId );
        history.push ( "/" + props.menuItem.topMenuPath + "/" + props.menuItem.menuPath );

    }

    return <SubMenuSelectItem menuItem={props.menuItem} onClick={onClick} />

}

export default SubMenuItem;
